export const isBrowser: boolean = typeof window !== 'undefined'

export const isNavigator: boolean = typeof navigator !== 'undefined'

export const userAgent: string = isNavigator ? navigator?.userAgent : ''

export function isWebview(): boolean {
  const ua = isNavigator ? navigator?.userAgent : ''

  if (!ua) return false

  const lower = ua.toLowerCase()

  const isAndroidMobile = /(androidmobile|rumdik\/)/i.test(ua)

  /**
   * Detect Android WebView tokens:
   * - 'wv' token (common in Android WebView UAs, e.g. "...; wv) ...")
   * - explicit 'webview' token
   */

  const hasWv = /\bwv\b/.test(lower)
  const hasWebviewToken = /webview/.test(lower)

  return isAndroidMobile || hasWv || hasWebviewToken
}
